import { render, staticRenderFns } from "./TxTableHead.vue?vue&type=template&id=9ae5f70a&scoped=true&"
import script from "./TxTableHead.vue?vue&type=script&lang=ts&"
export * from "./TxTableHead.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ae5f70a",
  null
  
)

export default component.exports